import { BackgroundImage } from "@/components/backgroundImage"
import { LogoHeader } from "@/components/logoHeader";
import { Select } from "@/components/select"
import { unidades } from "@/constants/unidades"
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

function Unidade() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!location.state?.can_stay) {
      navigate("/", { replace: true })
    }
  }, [location.state]);

  return (
    <div className="mx-auto max-w-[500px] min-h-screen px-2 pb-8">
      <LogoHeader />
      <div className="flex flex-col galp-4 px-4">
        <BackgroundImage height="h-[350px]" alt="Address-rafiki.png" src="/assets/Address-rafiki.png" />

        <p className="text-2xl font-bold text-center">
          Qual unidade você tem<br />interesse de atendimento?
        </p>

        <div className="flex flex-col gap-2 px-2 mt-6">
          {unidades.options.map((item, idx) => (
            <Select id={item.id} key={idx} idx={idx + 1} label={item.label} />
          ))}
        </div>

      </div>

    </div>
  )
}

export default Unidade

